import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Redirect, useParams } from 'react-router';

import { useStore } from 'stores';
import * as paths from 'app-router/paths';
import Loading from 'components/Loading';
import { ErrorMessage } from 'components/Message';
import { LabeledIcon, ReloadIcon, RequestersIcon } from 'components/Icon';
import { FormCard } from 'components/Card';

import { ViewForm } from './ViewForm';

export const Page: React.FC = observer(() =>
{
  const [needToLoad, setNeedToLoad] = useState(true);
  const { requesterToken } = useParams<{requesterToken: string}>();
  const { uiStore, requesterStore } = useStore();

  const reloadData = async () => await requesterStore.getByTokenAsync(requesterToken);

  useEffect(() =>
  {
    if (!requesterStore.requester.data || requesterStore.requester.data.token !== requesterToken)
    {
      requesterStore.getByTokenAsync(requesterToken);
    }
    setNeedToLoad(prev => false);
  }, [requesterToken, requesterStore, setNeedToLoad]);

  return (
    <article className="page audience requester-view">
      <FormCard>
      {
        requesterStore.requester.isLoading || needToLoad
        ? <><h1>{uiStore.labels.common.loading}</h1><Loading /></>
        : requesterStore.requester.isError
          ? <>
              <h1>{uiStore.labels.common.anErrorOccured}</h1>
              <ErrorMessage>{requesterStore.requester.errorMessage} <button onClick={reloadData}><LabeledIcon label={uiStore.labels.common.tryAgain}><ReloadIcon/></LabeledIcon></button></ErrorMessage>
            </>
          : requesterStore.requester.data
            ? <>
                <h1><RequestersIcon />{requesterStore.requester.data.name}</h1>
                {requesterStore.requester.errorMessage ? <ErrorMessage>{requesterStore.requester.errorMessage}</ErrorMessage> : null}
                <ViewForm requester={requesterStore.requester.data} />
              </>
            : <Redirect to={paths.buildNotFoundPath()} />
      }
      </FormCard>
    </article>
  );
});